var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1723 4.79354C20.5758 5.2074 20.5758 5.87595 20.1723 6.28981L18.2789 8.23177L14.3989 4.25234L16.2923 2.31038C16.4856 2.11167 16.7481 2 17.0217 2C17.2954 2 17.5579 2.11167 17.7512 2.31038L20.1723 4.79354ZM1.849 20.5733V17.3473C1.849 17.1987 1.90073 17.0714 2.0042 16.9653L13.2922 5.38779L17.1722 9.36722L5.87379 20.9447C5.78067 21.0508 5.64617 21.1039 5.51166 21.1039H2.36632C2.07662 21.1039 1.849 20.8704 1.849 20.5733Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.86157,
    y: 19.6362,
    width: 13.1384,
    height: 1.31384,
    rx: 0.656921
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2fcc1829.svg";
export { ForwardRef as ReactComponent };